/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { ZoneContextManager } from '@opentelemetry/context-zone-peer-dep';
export type {
  Func,
  TargetWithEvents,
} from '@opentelemetry/context-zone-peer-dep';
import 'zone.js';
